// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"3827":"css/admin-app.6974","7672":"css/app.6974"}[chunkId] + ".css";
};